









import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component
export default class UnexpectedError extends Vue {
  @Prop({ default: 'p' })
  readonly tag: string
}
